export default {
    tablinks: [
        {
            path: "/contentmanagement/sessions/addsessiondetails",
            label: "Session Details",
            id: "sessiondetails"

        },
        {
            path: "/contentmanagement/sessions/addvideos",
            label: "Videos",
            id: "videos"

        },
        {
            path: "/contentmanagement/sessions/addppt",
            label: "Manual",
            id: "manual"

        },
        {
            path: "/contentmanagement/sessions/addhandouts",
            label: "Handouts",
            id: "handouts"

        },
        {
            path: "/contentmanagement/sessions/addzip",
            label: "App",
            id: "addzip"

        },
        {
            path: "/contentmanagement/sessions/addarvr",
            label: "Augmented Reality",
            id: "ar"

        },
        {
            path: "/contentmanagement/sessions/addassessments",
            label: "Assessments",
            id: "assessments"

        },
    ]
}